'use client';

import { ReactNode, createContext, useContext } from 'react';
const AuthShellPendingContext = createContext(false);
export function AuthShellPendingProvider({
  pending,
  children
}: {
  pending: boolean;
  children: ReactNode;
}) {
  return <AuthShellPendingContext.Provider value={pending} data-sentry-element="AuthShellPendingContext.Provider" data-sentry-component="AuthShellPendingProvider" data-sentry-source-file="auth-shell-pending-context.tsx">
      {children}
    </AuthShellPendingContext.Provider>;
}

/** True while the `(main)` layout stream has not applied `resolveAuth()` yet. */
export function useAuthShellPending(): boolean {
  return useContext(AuthShellPendingContext);
}